import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Box, Chip, Typography } from "@mui/material";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { ClientSessionsSummary } from "./ClientSessionsSummary";
import { useClientSessionsSummary } from "../../api/client-sessions-summary";
import { getClientCurrentTreatment } from "../../utils/getClientCurrentTreatment";

type ClientHeaderProps = {
    actions?: Actions;
};

export const ClientHeader = ({ actions }: ClientHeaderProps) => {
    const recordContext = useContext(RecordContext);

    const { data: sessions, status } = useClientSessionsSummary(recordContext?.item?.id);

    if (!recordContext) return null;
    const mostRecentTreatment = getClientCurrentTreatment(recordContext?.item?.treatments);

    const treatmentId = mostRecentTreatment ? mostRecentTreatment.id : null;
    const { user_first_name, user_last_name, client_id, clinic_id } = recordContext.item;



    return (
        <DetailHeader actions={actions} collection={recordContext.collection}>
            <Box display="flex" columnGap={10}>
                <Box sx={{ width: "20%" }}>
                    <Typography variant="h6" color="secondary">
                        Cliente
                    </Typography>
                    <Box display="flex" alignItems="center" columnGap={2}>
                        <Typography variant="h5">{client_id}</Typography>
                        <Chip label={clinic_id.name} size="small" sx={{ px: 1 }} />
                    </Box>
                    <Typography variant="body1">
                        {user_first_name} {user_last_name}
                    </Typography>

                </Box>
                <Box sx={{ width: "80%" }}>
                    <ClientSessionsSummary sessions={sessions} treatmentId={treatmentId} options={{ flexDirection: "row", presentation: "header" }} isLoading={status === "loading"} />
                </Box>
            </Box>
        </DetailHeader>
    );
};
